/* Logout component */
import * as Sentry from "@sentry/react";
import React, { useEffect } from "react";
import { usePost } from "seed/api";

function Logout({ history, location }) {

  const params = new URLSearchParams(location.search);

  const logout = () => {
    // Clear all storages with exceptions
    clearStorage(sessionStorage, []);
    clearStorage(localStorage, [
      "flow_id"
    ]);
    Sentry.setUser(null);
    
    // Store flow token if present in URL to customize login after logout
    if (params.get("flow_token") && params.get("flow_token") != "")
      localStorage.setItem("flow_token", params.get("flow_token"));
    
    // Redirect to login page
    history.replace("/login");
  }

  const clearStorage = (storage, exclude) => {
    const keys = Object.keys(storage);
    keys.forEach(key => {
      if (!exclude.includes(key)) {
        storage.removeItem(key);
      }
    });
  }

  const [callLogout] = usePost("/auth/logout", {
    onCompleted: () => logout(),
    onError: () => logout()
  });

  useEffect(() => callLogout(), []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div />;
}

export default Logout;